import Gooey, {
    mount,
    model,
    Component,
    field,
    calc,
    Dyn,
    dynSet,
} from '@srhazi/gooey';
import { NumberInput } from './number-input';
import { StringInput } from './string-input';
import { BooleanInput } from './boolean-input';
import './fixture.css';

type PropDef =
    | readonly [
          'number',
          number,
          {
              type?: 'number' | 'range';
              min?: number;
              max?: number;
              step?: number;
          }
      ]
    | readonly ['string', string, {}]
    | readonly ['children', string, {}]
    | readonly ['boolean', boolean, {}];

type PropDefs<TProps> = {
    [k in keyof TProps]: PropDef;
};

let maxId = 0;

export function Fixture<TProps>({
    Component,
    propDefs,
}: {
    Component: Component<any>;
    propDefs: PropDefs<TProps>;
}) {
    const id = `fixture_${maxId++}`;
    const inputs: JSX.Node[] = [];
    const start: any = {};
    for (const key of Object.keys(propDefs)) {
        if (propDefs[key as keyof TProps][0] !== 'children') {
            start[key] = propDefs[key as keyof TProps][1];
        }
    }
    const dynamic = model(start);
    const props: any = {};
    for (const key of Object.keys(propDefs)) {
        const propDef = propDefs[key as keyof TProps];
        switch (propDef[0]) {
            case 'number': {
                const keyField = model.field(dynamic, key);
                props[key] = keyField;
                const fieldId = `${id}_${key}`;
                inputs.push(<label for={fieldId}>{key}: </label>);
                inputs.push(
                    <NumberInput
                        id={fieldId}
                        value={keyField}
                        type={propDef[2].type}
                        min={propDef[2].min}
                        max={propDef[2].max}
                        step={propDef[2].step}
                    />
                );
                break;
            }
            case 'string': {
                const keyField = model.field(dynamic, key);
                props[key] = keyField;
                const fieldId = `${id}_${key}`;
                inputs.push(<label for={fieldId}>{key}: </label>);
                inputs.push(<StringInput id={fieldId} value={keyField} />);
                break;
            }
            case 'boolean': {
                const keyField = model.field(dynamic, key);
                props[key] = keyField;
                const fieldId = `${id}_${key}`;
                inputs.push(<label for={fieldId}>{key}: </label>);
                inputs.push(<BooleanInput id={fieldId} value={keyField} />);
                break;
            }
            case 'children': {
                const htmlField = field(propDef[1]);
                const elementsCalc = calc(() => {
                    const span = document.createElement('span');
                    span.innerHTML = htmlField.get();
                    return span;
                });
                props[key] = <>{elementsCalc}</>;
                const fieldId = `${id}_${key}`;
                inputs.push(<label for={fieldId}>{key}: </label>);
                inputs.push(<StringInput id={fieldId} value={htmlField} />);
                break;
            }
        }
    }
    console.log('props', props);
    return (
        <div class="fixture">
            <div class="fixture_inputs">{inputs}</div>
            <div class="fixture_body">
                <Component {...props} />
            </div>
        </div>
    );
}
